import {h, Fragment} from "preact"
import { useEffect, useState } from "preact/hooks";
import { GQL_KEY } from "../config"
import { getSkuColor } from "../helpers"

export default function Swatches({ relatedProduct, currentProduct }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // const body = `
    //   query {
    //     products(
    //       limit: 100
    //       offset: 0
    //       filter: {
    //         tags1: "${relatedProduct}"
    //         availability: "InStock"
    //       }
    //     ) {
    //       products {
    //         productId
    //         availability
    //         url
    //         price
    //         listPrice
    //         thumbUrl
    //         url
    //         name
    //         skus {
    //           name
    //         }
    //       }
    //     }
    //   }
    // `;

    const body = `
      query {
        products(
          limit: 100
          offset: 0
          filter: {
            customFields:{
              attribute: "custom-related_styles"
              values: "${relatedProduct}"
            }
            availability: "InStock"
          }
        ) {
          products {
            productId
            availability
            url
            price
            listPrice
            thumbUrl
            url
            name
            skus {
              name
            }
          }
        }
      }
    `;

    fetch('https://api.nosto.com/v1/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'Authorization': 'Basic ' + btoa(":" + GQL_KEY)
      },
      body: body
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // console.log("SWATCHES ARE", currentProduct.name, data);
        setProducts(data?.data?.products?.products || []);
        setLoading(false);
      })
      .catch(error => {
        // console.error('Request failed:', error);
        setLoading(false);
      });
  }, [relatedProduct]);

  const handleLabelClick = function(event){
    // console.log("EVENT.TARGET", event.target.closest(".ns-color-swatch").querySelector("input"))
    console.log("ALL INPUTS", event.target.closest(".ns-prod-swatches").querySelectorAll("input"));
    // console.log("JUST THE INPUT TO CHECK", event.target.closest("input"));
    event.target.closest(".ns-prod-swatches").querySelectorAll("input").checked = false;
    event.target.closest(".ns-color-swatch").querySelector("input").checked = true;
  }


  // Optional: loading indicator
  if (loading) return <div>Loading...</div>;

  return (
    <div className="ns-prod-swatches">
        <div className="ns-color-swatch" key={currentProduct.productId}>
              <input 
                type="radio" 
                className="ns-color-swatch-input"
                id={`swatch-serp-${currentProduct.productId}`}
                name={`ns-serp-${currentProduct.productId}-color`}
                value={currentProduct.productId}
                data-image="$!color.getFirstSku().imageUrl"
                checked
              />
              <label
                className="ns-color-swatch-label"
                onClick={(e)=> window.location.href = `${product.url}`}
                htmlFor={`swatch-serp-${currentProduct.productId}`}
                nosto-img={currentProduct.thumbUrl}
                nosto-price={currentProduct.price}
                nosto-listprice={currentProduct.listPrice}
                nosto-url={currentProduct.url}
              >
                <img
                  className="ns-color-swatch-img"
                  // src={`https://www.thefryecompany.com/cdn/shop/files/productcolor__${currentProduct.name.split(" - ")[0]?.toLowerCase().replaceAll("/","").replaceAll(" ", "-").replaceAll(":", "").replaceAll("-&","")}-${getSkuColor(currentProduct.skus[0].name)}.png?crop=center&height=16&v=1678805722&width=16`}
                  src={`https://www.thefryecompany.com/cdn/shop/files/productcolor__${currentProduct.url?.split("/")?.pop()}.png?crop=center&height=16&v=1678805722&width=16`}
                  alt={`color swatch ${currentProduct.skus[0].name}`}
                  width="16"
                  height="16"
                />
              </label>
            </div>
      
      {products.filter(product => product.availability === "InStock").map((product, index) => {
        const productHandle = product.url?.split("/")?.pop();
        if (index < 5 && product.url != currentProduct.url) {
          return (
            <div className="ns-color-swatch" key={product.productId}>
              <input 
                type="radio" 
                className="ns-color-swatch-input"
                id={`swatch-serp-${product.productId}`}
                name={`ns-serp-${product.productId}-color`}
                value={product.productId}
                data-image="$!color.getFirstSku().imageUrl"
              />
              <label
                className="ns-color-swatch-label"
                htmlFor={`swatch-serp-${product.productId}`}
                nosto-img={product.thumbUrl}
                nosto-price={product.price}
                nosto-listprice={product.listPrice}
                nosto-url={product.url}
                onClick={(e)=> window.location.href = `${product.url}`}
              >
                <img
                  className="ns-color-swatch-img"
                  // src={`https://www.thefryecompany.com/cdn/shop/files/productcolor__${product.name.split(" - ")[0]?.toLowerCase().replaceAll("/","").replaceAll(" ", "-").replaceAll("-&","").replaceAll(":", "")}-${getSkuColor(product.skus[0].name)}.png?crop=center&height=16&v=1678805722&width=16`}
                  src={`https://www.thefryecompany.com/cdn/shop/files/productcolor__${productHandle}.png?crop=center&height=16&v=1678805722&width=16`}
                  alt={`color swatch ${product.skus[0].name}`}
                  width="16"
                  height="16"
                />
              </label>
            </div>
          );
        } else if (index === 5) {
          // Show only once after 5th item
          const remaining = products.length - 5;
          return (
            <a 
            href={`${product.url}`}
            class="ns-swatch-count"
        >
            +{remaining}
        </a>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}